import {Message} from "element-ui";

export function listToTree(data, idName, parentIdName) {
    if (!idName) {
        idName = 'id';
    }
    if (!parentIdName) {
        parentIdName = 'parentId';
    }

    // * 先生成parent建立父子关系
    const obj = {};
    data.forEach((item) => {
        // item[idName] = item[idName].toString();
        // item[parentIdName] = item[parentIdName].toString();
        obj[item[idName]] = item;
    });
    const parentList = [];
    data.forEach((item) => {
        // item.hasChildren = false;
        const parent = obj[item[parentIdName]];
        if (parent) {
            // * 当前项有父节点
            parent.children = parent.children || [];
            parent.children.push(item);
            // parent.hasChildren = true;
        } else {
            // * 当前项没有父节点 -> 顶层
            parentList.push(item);
        }
    });
    return parentList;
}

/**
 * 校验密码，首字母，必须包含数字，大小写，特殊字符
 * @param password
 * @returns {*}
 */
export function matchPassword(password) {
    var pattern0 = /^[a-zA-Z]/;
    var pattern = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_])/;
    return password.match(pattern0) && password.match(pattern);
}

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//计算度量元的值
export function calculateFormula(formula, params, name) {
    params.sort((a, b) => b.sign.length - a.sign.length);
    // 替换公式中的参数为具体的值
    params.forEach(item => {
        formula = formula.replace(new RegExp(item.sign, 'g'), item[name]);
    })

    // 使用eval计算公式
    let result = eval(formula);
    return result.toFixed(4);
}

//验证分子比分母小
export function evaluateExpression(formula, params, name) {
    params.sort((a, b) => b.sign.length - a.sign.length);
    // 替换公式中的参数为具体的值
    params.forEach(item => {
        formula = formula.replace(new RegExp(item.sign, 'g'), item[name]);
    })
    // 假设表达式是一个包含数字和操作符的字符串
    // 例如: "3 + 4 * 2 / (1 - 5)^2"

    // 解析表达式的逻辑将在这里实现
    // 为了简化，这里我们只检查除法操作
    const tokens = formula.split(' ');

    for (let i = 0; i < tokens.length; i++) {
        if (tokens[i] === '/') {
            // 找到除法操作符，获取分子和分母
            const numerator = parseFloat(tokens[i - 1]);
            const denominator = parseFloat(tokens[i + 1]);

            // 检查分子是否大于分母
            if (numerator > denominator) {
                return false
            }
        }
    }
    return true
}

//计算归一化的值
export function calculateFormulaNew(value, item) {
    let minVal = parseFloat(item.minVal)
    let maxVal = parseFloat(item.maxVal)
    value = parseFloat(value)
    let score = 0
    if(item.pointLimit == 'BENEFIT'){
        if(value < minVal){
            score = 0
        }else if(value > maxVal){
            score = 100
        }else{
            score = (value - minVal)*100/(maxVal-minVal)
        }

    }else if(item.pointLimit == 'COSTORIENTED'){
        if(value < minVal){
            score = 100
        }else if(value > maxVal){
            score = 0
        }else{
            score = (maxVal - value)*100/(maxVal-minVal)
        }
    }


    return score.toFixed(2);
}

export function getMemoryList(){
    return [
        {name:"超强", min: 999000, max:null},
        {name:"强", min: 100000, max:999000},
        {name:"中", min: 32000, max:100000},
        {name:"稍弱", min: null, max:32000}
    ]
}
